export default "__VITE_ASSET__b2b60469__"